export default __webpack_public_path__ + "static/media/pankcake.e1d4dec3.png";